import React, { useContext, useState } from "react";
import { Menu, Layout, Button, Row, Col, Space } from "antd";
import "./style.css";
import CONSTANTS from "constants/constants";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Drawer } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import SubMenu from "antd/es/menu/SubMenu";
import useWindowDimensions from "utils/WindowDimensions";
import { Context } from "Context";

const Header = (props) => {
  const { current, setCurrent } = useContext(Context);
  const { width } = useWindowDimensions();
  const { Header } = Layout;
  const { HEADER } = CONSTANTS;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleClick = (e) => {
    setCurrent(e.key);
    onClose();
  };

  const menuItems = (
    <Menu
      selectedKeys={[current]}
      theme={current === "/ourServices/prodRed" ? "dark" : "light"}
      onClick={handleClick}
      mode="inline"
    >
      <Menu.Item key="/">
        <Link to="/">{HEADER.HOME}</Link>
      </Menu.Item>
      <Menu.Item key="/aboutUs">
        <Link to="/aboutUs">{HEADER.ABOUT_US}</Link>
      </Menu.Item>
      <SubMenu title={HEADER.OUR_SERVICES} key="/ourServices">
        <Menu.Item key="/ourServices/prodRed">
          <Link to="/ourServices/prodRed">{HEADER.PROD_RED}</Link>
        </Menu.Item>
        <Menu.Item key="/ourServices/dvt">
          <Link to="/ourServices/dvt">{HEADER.DVT}</Link>
        </Menu.Item>
        <Menu.Item key="/ourServices/marketPulse">
          <Link to="/ourServices/marketPulse">{HEADER.MARKET_PULSE}</Link>
        </Menu.Item>
      </SubMenu>
      <Menu.Item key="/contactUs">
        <Link to="/contactUs">{HEADER.CONTACT_US}</Link>
      </Menu.Item>
    </Menu>
  );

  const items = [
    {
      label: (
        <Link to="/" className="header-nav-link">
          {HEADER.HOME}
        </Link>
      ),
      key: "/",
    },
    {
      label: (
        <Link to="/aboutUs" className="header-nav-link">
          {HEADER.ABOUT_US}
        </Link>
      ),
      key: "/aboutUs",
    },
    {
      label: (
        <span className="header-nav-link">
          {HEADER.OUR_SERVICES}
          {isSubMenuOpen ? (
            <FontAwesomeIcon icon={faChevronUp} className="header-down-icon" />
          ) : (
            <FontAwesomeIcon
              icon={faChevronDown}
              className="header-down-icon"
            />
          )}
        </span>
      ),
      key: "/ourServices",
      children: [
        {
          label: <Link to="/ourServices/prodRed">{HEADER.PROD_RED}</Link>,
          key: "/ourServices/prodRed",
        },
        {
          label: <Link to="/ourServices/dvt">{HEADER.DVT}</Link>,
          key: "/ourServices/dvt",
        },
        {
          label: <Link to="/ourServices/marketPulse">{HEADER.MARKET_PULSE}</Link>,
          key: "/ourServices/marketPulse",
        },
      ],
    },
  ];

  return (
    <Header className="header-container">
      <Row className="display-flex justify-content-between">
        <Col md={12} className="display-flex align-items-center">
          <Link
            to="/"
            onClick={() => setCurrent("/")}
            className="header-text-main"
          >
            <span className="header-text">{`\u1E5A`}</span>
            <span className="header-text-two">tam</span>
          </Link>
        </Col>
        {width <= 768 ? (
          <Col className="display-flex align-items-center">
            <FontAwesomeIcon
              icon={faBars}
              onClick={showDrawer}
              className="header-drawer-icon"
            />
            <Drawer
              title=" "
              placement="right"
              closable={false}
              onClose={onClose}
              open={open}
              extra={
                <FontAwesomeIcon
                  icon={faXmark}
                  onClick={onClose}
                  className="header-drawer-close"
                />
              }
              className="header-mobile-drawer"
            >
              {menuItems}
            </Drawer>
          </Col>
        ) : (
          <Col className="header-links" md={12}>
            <Space align="center">
              <Menu
                className="header-navs"
                onClick={handleClick}
                selectedKeys={[current]}
                mode="horizontal"
                items={items}
                onOpenChange={(e) => setIsSubMenuOpen(e.length ? true : false)}
              />
              <Button
                type="primary"
                className="contact-menu-btn"
                size="large"
                onClick={() => {
                  setCurrent("/contactUs");
                  navigate("/contactUs");
                }}
              >
                Contact Us
              </Button>
            </Space>
          </Col>
        )}
      </Row>
    </Header>
  );
};

export default Header;
